import { render, staticRenderFns } from "./IsapreTypeList.vue?vue&type=template&id=30d9c9b4&lang=pug&"
import script from "./IsapreTypeList.vue?vue&type=script&lang=js&"
export * from "./IsapreTypeList.vue?vue&type=script&lang=js&"
import style0 from "./IsapreTypeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IsapreTypeList.vue"
export default component.exports